import { type OfferV11 } from '@redteclab/api/clients/bully'

export const priceAccessorGetThirtyDaysDiscountFromOffer = (
  offer: OfferV11,
): number => {
  return (
    offer.offerPrice?.additionalInformation?.discount
      ?.percentageCheapestPriceBase ?? 0
  )
}
